import { createAction } from "@reduxjs/toolkit";

export const clearAllUsers = createAction('clearAllUsers');
export const setPlacedOrders = createAction('setPlacedOrders');